import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { NbToastrService } from "@nebular/theme";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { WarningDialogComponent } from "../../shared/dialogs/warning/dialog.warning.component";
import { CookieService } from "ngx-cookie-service";

@Injectable()
export class WSErrorInterceptor implements HttpInterceptor {
  pathBaseTranslate: string = "general.ws-error-interceptor";

  constructor(
    private toastrService: NbToastrService,
    private router: Router,
    private translateService: TranslateService,
    private modalService: NgbModal,
    private cookieService: CookieService,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const excludesUrl =
      req.url.includes("assets") ||
      req.url.includes("devices/register") ||
      req.url.includes("devices/sync");

    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        return event;
      }),
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (!excludesUrl) {
            if (err.status === 419) {
              this.cookieService.deleteAll("/");
              window.location.reload();
              return throwError(err);
            } else if (err.status === 401) {
              console.log(err);
              const subError: string =
                err.error?.sub_error || err.error?.subError || err.error?.code;
              if (req.url.indexOf("/login") !== -1) {
                this.toastrService.warning(
                  err.error?.message,
                  this.getTranslate(`${this.pathBaseTranslate}.titleWarning`),
                );
              } else if (subError === "DEVICE_KICKED") {
                this.toastrService.warning(
                  err.error?.message ||
                    "Seu acesso foi encerrado por login em outro dispositivo.",
                  this.getTranslate(`${this.pathBaseTranslate}.titleWarning2`),
                );
                this.router.navigateByUrl("logout");
              } else {
                this.toastrService.warning(
                  err.error?.message,
                  this.getTranslate(`${this.pathBaseTranslate}.titleWarning2`),
                );
                this.router.navigateByUrl("logout");
              }
            } else if (
              err.statusText === "OK" &&
              err.status === 406 &&
              err.url.includes("comment")
            ) {
              this.toastrService.warning(
                err.error.message,
                this.getTranslate(`${this.pathBaseTranslate}.titleWarning3`),
              );
            } else if (
              err.status === 406 &&
              err.error !== undefined &&
              err.error.message !== undefined
            ) {
              const activeModal = this.modalService.open(
                WarningDialogComponent,
                {
                  backdrop: "static",
                  keyboard: false,
                  centered: true,
                  windowClass: "modal-confirm",
                },
              );
              activeModal.componentInstance.content = err.error.message;
            } else {
              this.toastrService.danger(
                this.getTranslate(`${this.pathBaseTranslate}.messageError`),
                this.getTranslate(`${this.pathBaseTranslate}.titleError`),
              );
            }
          }
        } else {
          this.toastrService.danger(
            this.getTranslate(`${this.pathBaseTranslate}.messageError`),
            this.getTranslate(`${this.pathBaseTranslate}.titleError`),
          );
        }
        return throwError(err);
      }),
    );
  }

  getTranslate(key: string): string {
    let translation: string;
    this.translateService.get(key).subscribe((text: string) => {
      translation = text;
    });
    return translation;
  }
}
